import React from 'react';

import { Spinner as SpinDesktop } from '@yandex-360/orb-components/dist/components/Spinner';

type SpinnerProps = React.ComponentProps<typeof SpinDesktop> & {
    color?: string;
};

const Spin = ({ color, ...props }: SpinnerProps) => {
    const spinnerColor = color ?? 'var(--spin-view-default-border-color)';
    return <SpinDesktop color={spinnerColor} {...props} />;
};

export default Spin;
